const ar = {
    heloo: "مرحبا",
    change_language: "تغيير اللغة",
    home: "الصفحة الرئيسية",
    create_augmented_reality: "إنشاء واقعية معززة",
    orders: "الطلبات",
    payments: "المدفوعات",
    camera: "كاميرا",
    constructed_augmented: "الواقعيات المعززة المنشأة",
    total_payments: "إجمالي المدفوعات",
    number_views_files: "عدد مرات عرض جميع الملفات",
    augmented_gallery: "معرض الواقعيات المعززة",
    view_all: "عرض الكل",
    gallery_videos: "معرض الفيديوهات والأخبار",
    number_of_visits: "عدد الزيارات",
    production_date: "تاريخ الإنتاج",
    video_not_found: "لم يتم العثور على الفيديو الإعلاني",
    profile: "الملف الشخصي",
    edit_profile: "تحرير الملف الشخصي",
    sign_out: "تسجيل الخروج",
    Your_profile_is_inactive: "الملف الشخصي غير نشط",
    fill_the_box_below: "يرجى ملء الصندوق أدناه",
    augmented_reality_code: "رمز الواقعية المعززة",
    registration: "التسجيل",
    link: "الرابط",
    financial_reports: "التقارير المالية",
    search: "البحث",
    search_in: "البحث في...",
    Paid: 'تم الدفع',
    Repayment: "إعادة الدفع",
    free: "مجاني",
    yearly: "سنوي",
    create_two_images: "إنشاء صورتين",
    ten_visits_per_year: "10 زيارات سنوية",
    business_facilities: "مرافق الأعمال",
    selection: "اختيار",
    business: "أعمال",
    toman: "$",
    no_visit_limit: "بدون حدود زيارة سنوية",
    extendable: "قابل للتمديد سنويًا",
    ability_multiple_images: "القدرة على إضافة عدة صور (بتكلفة أقل)",
    hyperlink: "روابط هايبرلنك (موقع الويب، الاتصال، إنستجرام، دليل المستخدم)",
    personal: "شخصي",
    visits_per_year_360: "360 زيارة سنوية",
    create_an_image: "إنشاء صورة",
    the_image_below_is_5mb: "يجب أن يكون حجم الصورة أقل من 5 ميغابايت",
    the_video_below_is_50mb: "يجب أن يكون حجم الفيديو أقل من 50 ميغابايت",
    your_photo: "صورتك",
    tip: "تلميح",
    your_video: "فيديوك",
    names: "الأسماء",
    more_settings: "+ إعدادات إضافية",
    fewer_settings: "- إعدادات أقل",
    price: "السعر",
    send: "إرسال",
    uploading: "جارٍ تحميل الفيديو وتحويله، قد يستغرق هذا الإجراء بضع دقائق ، يرجى الانتظار",
    site_link: "رابط الموقع",
    help_site: 'موقع الدليل',
    phone_number: "رقم الهاتف",
    your_qr_code: "رمز الاستجابة السريعة الخاص بك",
    scan_qr_code: "يمكنك مسح رمز الاستجابة السريعة أدناه وتنزيل عنوان URL أو نسخه.",
    dates: "تواريخ",
    visit: "زيارة",
    copy: "نسخ",
    download_qr_code: "تحميل رمز الاستجابة السريعة",
    successful_payment: "دفع ناجح",
    thank_you_for_payment: "شكرًا لإتمام دفعتك الأمنة عبر الإنترنت",
    are_you_sure_to_exit: "هل أنت متأكد من الخروج؟",
    yes_im_sure: "نعم، أنا متأكد",
    no_thanks: "لا شكرًا",
    cancel_augmented_reality: "إلغاء الواقع المعزز",
    download: "تحميل",
    please_enter_augmented: "يرجى إدخال معرف الواقع المعزز الخاص بك",
    id: "معرف",
    please_wait: "يرجى الانتظار",
    instagram_username: "اسم مستخدم Instagram (دون علامة @)",
    create_an_account: "إنشاء حساب لـ IR Live",
    complete_the_form: "اكمل النموذج لانشاء حسابك",
    form_registration: "الاسم الأول والأخير (اسم المؤسسة)",
    phone: "رقم الهاتف المحمول",
    select_the_country: "حدد البلد",
    user_name: "اسم المستخدم",
    please_use_english: "يرجى استخدام الأحرف اللاتينية فقط",
    password: "كلمة السر",
    password_must_be_six_digits: "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل وتحتوي على مزيج من الأرقام والحروف",
    show_password: "إظهار كلمة المرور",
    repeat_the_password: "تكرار كلمة المرور",
    select_the_language: "تغيير اللغة",
    register: "تسجيل",
    register_the_code: "تسجيل الرمز",
    enter_code: "أدخل الرمز",
    sent: "تم الإرسال",
    code_for_the_number: "الرمز الخاص بك",
    have_you_registered: "هل سبق لك التسجيل؟",
    log_in: "تسجيل الدخول",
    create_a_new_user_account: "إنشاء حساب مستخدم جديد",
    create_password_to_six: "إنشاء كلمة مرور تصل إلى ستة خانات",
    password_not_the_same: "كلمة المرور غير متطابقة",
    You_currently_with_account: "أنت حاليًا مسجل الدخول باستخدام حسابك",
    verification_code_is_incorrect: "رمز التحقق غير صحيح",
    registration_was_successful: "تم التسجيل بنجاح",
    fill: "املأ",
    login_to_account: "تسجيل الدخول إلى الحساب",
    login_via_password: "تسجيل الدخول عبر كلمة المرور",
    log_via_sms: "تسجيل الدخول عبر رسالة نصية قصيرة",
    form_nameValidation: "رقم الهاتف أو اسم المستخدم",
    send_code: "الكود المرسل",
    you_are_not_authenticated: "أنت لم تتم مصادقتك بعد",
    not_registered: "غير مسجل؟",
    passwordValidation: "كلمة المرور",
    code_successfully_verified: "تم التحقق من الرمز بنجاح",
    please_fill_name_validation: "يرجى ملء الاسم",
    please_fill_picture_validation: "يرجى ملء الصورة",
    you_cannot_multiple_photos_validation: "لا يمكنك تعريف صور متعددة",
    do_not_duplicate_videos_validation: "لا تضيف فيديو مكرر",
    do_not_duplicate_photos_validation: "لا تضيف صورة مكررة",
    video_more_50_MB_validation: "الفيديو أكبر من 50 ميجابايت",
    image_size_5mb_validation: 'حجم الصورة أكبر من 5 ميجابايت',
    fill_in_video_validation: "يرجى ملء الفيديو",
    fill_in_image_validation: "يرجى ملء الصورة",
    your_video_photos: "الفيديوهات والصور الخاصة بك",
    image: "صورة",
    video: "فيديو",
    payment_was_successful: 'تم الدفع بنجاح',
    go_to_home_page: "الانتقال إلى الصفحة الرئيسية",
    product_id: "معرف المنتج",
    return_main_page: "العودة إلى الصفحة الرئيسية",
    difficulty_paying: "مشكلة في الدفع",
    payment_not_successful: "لم يتم الدفع بنجاح",
    make_the_operation: "يرجى إعادة الدفع لإكمال العملية",
    return_the_page: "العودة إلى الصفحة الرئيسية",
    you_not_access: "ليس لديك صلاحية الوصول",
    qr_code: "رمز الاستجابة السريعة",
    link_was_copied: "تم نسخ الرابط",
    oreders: "الطلبات",
    payment_message: "رسالة الدفع",
    payment_failed: "فشل الدفع",
    payment_code: "رمز الدفع",
    does_not_exist: "غير موجود",
    card_number: "رقم البطاقة",
    wait: "يرجى الانتظار",
    edit: "التحرير",
    mission_was_successful: "تمت المهمة",
    Upload_a_new_video: "قم بتحميل فيديو جديد",
    Delete_augmented_reality: "إزالة الواقع المعزز",
    Are_you_sure_about_removing_augmented_reality: "هل أنت متأكد من إزالة الواقع المعزز؟",
    Are_you_sure_about_canceling_augmented_reality: "هل أنت متأكد من إلغاء الواقع المعزز؟",
    yes: "نعم",
    no: "لا",
    add: "يضيف",
    convertVideo: "تحويل الفيديو ، يرجى الانتظار",
    no_augmented: "لم يتم العثور على واقع معزز",

}
export default ar;